// Mobile menu toggle
const toggle = document.querySelector(".menu-toggle");
const nav = document.querySelector(".nav");
if (toggle && nav) {
  toggle.addEventListener("click", () => {
    nav.classList.toggle("is-open");
    const open = nav.classList.contains("is-open");
    toggle.setAttribute("aria-expanded", String(open));
  });
}

// Header subtle shadow on scroll
const header = document.querySelector(".site-header");
if (header) {
  const onScroll = () => {
    if (window.scrollY > 8) header.classList.add("is-scrolled");
    else header.classList.remove("is-scrolled");
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
}

// Reusable full-screen image zoom viewer (used by product gallery + carousel lightbox)
(function () {
  var zv = document.querySelector("[data-zoom-viewer]");
  if (!zv) return;
  var zImg = zv.querySelector("[data-zoom-img]");
  function open(src, alt) {
    if (!src) return;
    zImg.src = src;
    zImg.alt = alt || "";
    zImg.classList.remove("is-zoomed");
    zImg.style.transform = "";
    zv.hidden = false;
    document.body.style.overflow = "hidden";
  }
  function close() {
    zv.hidden = true;
    document.body.style.overflow = "";
    zImg.classList.remove("is-zoomed");
    zImg.style.transform = "";
  }
  // Open from any element carrying data-zoom-src
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-zoom-src]");
    if (!t) return;
    e.preventDefault();
    var alt = t.getAttribute("alt") || (t.querySelector("img") && t.querySelector("img").alt);
    open(t.getAttribute("data-zoom-src"), alt);
  });
  function pan(e) {
    if (!zImg.classList.contains("is-zoomed")) return;
    var p = e.touches && e.touches[0] ? e.touches[0] : e;
    var r = zImg.getBoundingClientRect();
    var x = Math.min(100, Math.max(0, ((p.clientX - r.left) / r.width) * 100));
    var y = Math.min(100, Math.max(0, ((p.clientY - r.top) / r.height) * 100));
    zImg.style.transformOrigin = x + "% " + y + "%";
    zImg.style.transform = "scale(2.4)";
  }
  zImg.addEventListener("click", function (e) {
    e.stopPropagation();
    if (zImg.classList.toggle("is-zoomed")) pan(e);
    else zImg.style.transform = "";
  });
  zImg.addEventListener("mousemove", pan);
  zImg.addEventListener("touchmove", function (e) { if (zImg.classList.contains("is-zoomed")) { e.preventDefault(); pan(e); } }, { passive: false });
  zv.addEventListener("click", function (e) { if (e.target === zv) close(); });
  zv.querySelector("[data-zoom-close]").addEventListener("click", close);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !zv.hidden) close(); });
})();

// Product gallery — thumbnails switch the main image
(function () {
  var main = document.querySelector("[data-pdp-main]");
  if (!main) return;
  var thumbs = document.querySelectorAll("[data-pdp-thumb]");
  thumbs.forEach(function (t) {
    t.addEventListener("click", function () {
      main.src = t.getAttribute("data-src");
      main.setAttribute("data-zoom-src", t.getAttribute("data-zoom-full"));
      main.alt = t.getAttribute("data-alt") || main.alt;
      thumbs.forEach(function (x) { x.classList.remove("is-active"); });
      t.classList.add("is-active");
    });
  });
})();
